import React from 'react';
import GCDWidget from '../GCD/GCDWidget';
import LoyaltyCartStrip from '../Loyalty/LoyaltyCartStrip';
import CartCount from './CartCount';
import './CartFooter.scss';
import isEmpty from 'lodash/isEmpty';


const CartFooter = ({ itemsCount, total, pldDiscountBuckets, loyaltyDetailsPitch, loyalty, selectedLPVariant }) => (
  <div className="CartFooterContainer" >
    {pldDiscountBuckets.length > 0 &&
    <GCDWidget
      itemsCount={itemsCount}
      total={total}
      pldDiscountBuckets={pldDiscountBuckets}
    />}
    {!isEmpty(loyalty) && !isEmpty(loyaltyDetailsPitch) &&
    <LoyaltyCartStrip loyaltyDetailsPitch={loyaltyDetailsPitch} loyalty={loyalty} selectedVariant={selectedLPVariant} />
    }
    <CartCount itemsCount={itemsCount} total={total} />
    <div className="DisclaimerText">
      Prices shown above are an estimate, the actual prices will be notified once your order is ready for dispatch.
      </div>
  </div>
);

export default CartFooter;
